(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    window.PXUTheme.theme_settings.cart_action_type === 'ajax' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    window.PXUTheme.cartDrawer.loadDrawer(true);
  });

  document.addEventListener('product-form:message:success', (event) => {
    event.preventDefault();
  });

  document.addEventListener('product-form:cart:update', (event) => {
    const { item_count } = event.detail.cart;
    window.PXUTheme.cartDrawer.updateCartCount(item_count);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story"] && !Shopify.designMode) return;
  try {
    
  const initializeOurStory = (root) => {
    if (root.dataset.storyInitialized === 'true') return;

    root.dataset.storyInitialized = 'true';
    const revealItems = root.querySelectorAll('[data-story-reveal]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    root.dataset.revealReady = 'true';
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.16, rootMargin: '0px 0px -8% 0px' }
    );

    revealItems.forEach((item) => observer.observe(item));
  };

  document.querySelectorAll('[data-our-story]').forEach(initializeOurStory);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-our-story]');
    if (root) initializeOurStory(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-template"]) return;
  try {
    
(function () {
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.reviews-page .reviews-action-button');
    if (!button || !button.href) return;

    event.preventDefault();
    event.stopPropagation();
    window.open(button.href, '_blank', 'noopener,noreferrer');
  }, true);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sell-shoes-wizard"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-sell-wizard]').forEach(function (wizard) {
    var state = { condition: '', count: 0 };
    function show(stepName) {
      wizard.querySelectorAll('[data-sell-step]').forEach(function (step) {
        step.hidden = step.getAttribute('data-sell-step') !== stepName;
      });
    }
    wizard.querySelectorAll('[data-sell-choice]').forEach(function (button) {
      button.addEventListener('click', function () {
        show(button.getAttribute('data-sell-choice') === 'trade' ? 'trade' : 'condition');
      });
    });
    wizard.querySelectorAll('[data-sell-condition]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.condition = button.getAttribute('data-sell-condition');
        show('count');
        wizard.querySelector('[data-sell-count]').focus();
      });
    });
    wizard.querySelector('[data-sell-continue]').addEventListener('click', function () {
      var input = wizard.querySelector('[data-sell-count]');
      var error = wizard.querySelector('[data-sell-error]');
      state.count = Number(input.value);
      error.hidden = state.count >= 1;
      if (state.count < 1) return;
      wizard.querySelector('[data-sell-summary]').textContent = 'You selected ' + state.condition.toLowerCase() + ' items. You have ' + state.count + ' item' + (state.count === 1 ? '' : 's') + '.';
      wizard.querySelector('[data-sell-condition-field]').value = state.condition;
      wizard.querySelector('[data-sell-count-field]').value = state.count;
      show('result');
    });
    wizard.querySelector('[data-sell-template-download]').addEventListener('click', function (event) {
      event.preventDefault();
      var link = event.currentTarget;
      var status = wizard.querySelector('[data-sell-download-status]');
      status.textContent = 'Preparing your template…';
      fetch(link.href)
        .then(function (response) {
          if (!response.ok) throw new Error('Download failed');
          return response.blob();
        })
        .then(function (blob) {
          var objectUrl = URL.createObjectURL(blob);
          var downloadLink = document.createElement('a');
          downloadLink.href = objectUrl;
          downloadLink.download = 'on-the-low-sell-inventory-template.csv';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          downloadLink.remove();
          URL.revokeObjectURL(objectUrl);
          status.textContent = 'Your inventory template has downloaded.';
        })
        .catch(function () {
          status.textContent = 'Your browser could not prepare the download. Opening the template instead.';
          window.location.assign(link.href);
        });
    });
    wizard.querySelector('[data-sell-csv-upload]').addEventListener('change', function (event) {
      var file = event.target.files[0];
      var status = wizard.querySelector('[data-sell-upload-status]');
      var payload = wizard.querySelector('[data-sell-csv-payload]');
      if (!file) {
        payload.value = '';
        status.textContent = 'CSV upload is optional, but it helps us review your items faster.';
        return;
      }
      if (!file.name.toLowerCase().endsWith('.csv')) {
        event.target.value = '';
        payload.value = '';
        status.textContent = 'Please choose a CSV file.';
        return;
      }
      var reader = new FileReader();
      reader.onload = function () {
        payload.value = reader.result;
        status.textContent = 'CSV ready to submit: ' + file.name;
      };
      reader.onerror = function () {
        payload.value = '';
        status.textContent = 'We could not read that CSV. Please try again.';
      };
      reader.readAsText(file);
    });
    wizard.querySelectorAll('[data-sell-back]').forEach(function (button) {
      button.addEventListener('click', function () { show(button.getAttribute('data-sell-back')); });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
